import { Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react'

export type TabItem = {
    label: string
    content: React.ReactNode
}

export type DataTabsProps = {
    data: TabItem[]
}

export default function DataTabs({ data }: DataTabsProps) {
    return (
        <Tabs size="md" colorScheme="brand">
            <TabList>
                {data.map(
                    (tab, index) => tab.label && <Tab key={index}>{tab.label}</Tab>
                )}
            </TabList>
            <TabPanels>
                {data.map(
                    (tab, index) =>
                        tab.content && (
                            <TabPanel p={4} key={index}>
                                {tab.content}
                            </TabPanel>
                        )
                )}
            </TabPanels>
        </Tabs>
    )
}
